import { render, staticRenderFns } from "./TrackerCompanySettings.vue?vue&type=template&id=c272be44&"
import script from "./TrackerCompanySettings.vue?vue&type=script&lang=js&"
export * from "./TrackerCompanySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports